import {EventAnalysisCollectionDto} from "../../../http/models/event-analysis-collection-dto";
import {EventDto} from "../../../../../../models/event/event-dto";
import {TimeRepository} from "../time/time-repository";
import {Injectable} from "@angular/core";
import {MultiEventAnalysisEventDto} from "../../../models/core/multi-event-analysis-event-dto";


@Injectable({
  providedIn: 'root'
})
export class EventRepository {
  events: EventDto[] = []

  constructor(private timeRepository: TimeRepository
  ) {
  }

  initialize(multiEventAnalysisEventDto: EventAnalysisCollectionDto[]) {
    this.initializeEvents(multiEventAnalysisEventDto)

    this.timeRepository.createGroupAxisNameMap(this.events)
  }


  private initializeEvents(multiEventAnalysisEventDto: MultiEventAnalysisEventDto[]) {
    for (let _multiEventAnalysisEventDto of multiEventAnalysisEventDto) {

      this.events.push(_multiEventAnalysisEventDto.eventDto)
    }

    this.events.sort((a, b) => {
      return new Date(a.start).getTime() - new Date(b.end).getTime()
    })
  }

  getEvents(): EventDto[] {
    return this.events
  }
}
